import React from 'react';
import { errorLogger } from '../../utils/trackingUtil';

class ErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    // logging application error
    errorLogger(error, errorInfo);
    try {
      window.clarity?.('event', 'react_error_boundary', {
        message: error.message,
        stack: error.stack,
        componentStack: errorInfo.componentStack,
      });
    } catch (e) {
      // to do
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}
export default ErrorBoundary;
